import { createContext } from 'react';

const PredefineItineraryContext = createContext();

export const ItineraryContext = PredefineItineraryContext;
export default PredefineItineraryContext;
